import {Endpoints} from '../../../../globals/api/endpoints';

export class CarouselEndpoints extends Endpoints {

  public static readonly CAROUSEL = CarouselEndpoints.VIEWER + '/carousel/' + CarouselEndpoints.PROJECT_ID;
}
